// Slice 41 — shared formatters for the licenses screen. Dates here are the
// `createdAt`/`revokedAt` HQ-storage unix-ms timestamps; `expiresAt` is the
// wire-contract unix-seconds field (spec §1 "Time" — the two units don't
// reconcile pre-GA).

export function fmtDateMs(ms: number | null | undefined): string {
  if (!ms) return "—";
  const d = new Date(ms);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function fmtDateSec(sec: number | null | undefined): string {
  if (!sec) return "never";
  return fmtDateMs(sec * 1000);
}

export function expiryTone(
  expiresAtSec: number | null | undefined,
  nowMs: number = Date.now(),
): "neutral" | "warn" | "danger" {
  if (!expiresAtSec) return "neutral"; // perpetual
  const expiresMs = expiresAtSec * 1000;
  const dDays = (expiresMs - nowMs) / (1000 * 60 * 60 * 24);
  if (dDays < 0) return "danger";
  if (dDays < 14) return "warn";
  return "neutral";
}

function pad(n: number): string {
  return n < 10 ? `0${n}` : String(n);
}

export function parseFeatures(serialised: string): string[] {
  try {
    const v = JSON.parse(serialised);
    return Array.isArray(v) ? v.map(String) : [];
  } catch {
    return [];
  }
}
